import React from 'react'
import "./Services.css";
import SerivceCard from '../SerivceCard';
import CaseStudies from '../CaseStudies';
import Hero from '../Hero';
import PricingModal from '../PricingModal';
import { hireDetails, serviceHeroDetails } from '../../utils/services';
import { servicePriceDetails } from '../../utils/services';
import Hire from '../Hire';
import Contact from '../Contact';
import { automationDetails } from '../../utils/automations';

function Services() {

  return (
    <section className='services'>
      <Hero {...serviceHeroDetails}/>
    <section className='our-services'>
      <p >Our serivces</p>
      <h2><span>Services</span> We Offer For You</h2>
      <p className='description'>We are comprehensive, offering you the software development services you need. Whether web, mobile, Artificial Intelligence, Machine Learning, or robotic solutions, we deliver all with expertise.</p>
      <div className='service-cards'>
      {automationDetails.map((automationDetail) => {
           return  <SerivceCard detail={automationDetail} key={automationDetail.id}/>
          })}

      </div>
    </section>
    {/* <CaseStudies/> */}
    {/* <PricingModal priceDetails={servicePriceDetails}/> */}
    <div className='padding'><Hire {...hireDetails}/></div>
    
    </section>
  )
}

export default Services